<template>
    <ModalContent name="group-modal" ref="modal" width="640px" v-bind="$attrs" v-on="$listeners" submitButtonText="Add">
        <template #title> Create Group </template>
        <template #content>
            <div class="flex gap-6 flex-col h-full">
                <FormulateForm class="min-h-full flex-1">
                    <FormulateInput class="w-full" label="Group Name" placeholder="Group Name" type="text" validation="required" :element-class="(context, classes) => ['flex-1 min-w-full'].concat(classes)" v-model="groupnameModel" />
                    <FormulateInput class="w-full" label="Group Description" placeholder="Group Description" type="textarea" validation="required" :element-class="(context, classes) => ['flex-1 min-w-full'].concat(classes)" v-model="groupdescriptionModel" />
                </FormulateForm>
                <h3 style="color: gray; opacity: 0.75">More settings will be available once the group is created</h3>
            </div>
        </template>
    </ModalContent>
</template>

<script>
import ModalContent from "@shared/modal-content";
export default {
    name: "create-group-modal",
    components: {
        ModalContent,
    },
    props: {
        groupname: {
            type: String,
            default: "",
        },
        groupdescription: {
            type: String,
            default: "",
        },
    },
    data() {
        return {};
    },
    computed: {
        groupnameModel: {
            get() {
                return this.groupname;
            },
            set(val) {
                this.$emit("update:groupname", val);
            },
        },
        groupdescriptionModel: {
            get() {
                return this.groupdescription;
            },
            set(val) {
                this.$emit("update:groupdescription", val);
            },
        },
    },
    // mounted(){
    //     this.closeModal();
    // },
    methods: {
        closeModal() {
            this.$modal.hide("group-modal");
        },
        submitForm() {
            this.$emit("submit", this.closeModal);
        },
    },
};
</script>

<style lang="scss" scoped></style>
